import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-8 md:py-12 text-center text-sm" data-id="element-129">
      <div className="container mx-auto px-4" data-id="element-130">
        <div className="mb-5 md:mb-8" data-id="element-131">
          <div className="text-xl md:text-2xl mb-2 md:mb-4" data-id="element-132">🧘</div>
          <h4 className="text-white font-serif font-bold text-base md:text-xl mb-1 md:mb-2" data-id="element-133">
            YOGA RESUELTA™ by RecursosFitness™
          </h4>
          <p className="max-w-md mx-auto text-xs md:text-sm" data-id="element-134">
            El sistema de clases N°1 para profes de Yoga en Argentina.
            <br data-id="element-135" />
            Porque enseñar Yoga no debería costarte todas las noches de la
            semana.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-8 mb-5 md:mb-8 text-xs md:text-sm" data-id="element-136">
          <a href="mailto:contacto@recursosfitness.shop" className="hover:text-white transition-colors" data-id="element-137">
            contacto@recursosfitness.shop
          </a>
          <span className="hidden md:inline" data-id="element-138">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-139">
            @recursosfitness.ar
          </a>
          <span className="hidden md:inline" data-id="element-140">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-141">
            recursosfitness.shop
          </a>
        </div>

        <div className="border-t border-gray-800 pt-5 md:pt-8 text-[10px] md:text-xs text-gray-500" data-id="element-142">
          <p data-id="element-143">© RecursosFitness.shop™ 2026 — Todos los derechos reservados.</p>
          <p className="mt-1" data-id="element-144">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}